import "./App.css";
import Routes from "./routes/Routes";
import AuthProvider from "./contexts/AuthProvider";
import WorkflowProvider from "./contexts/WorkflowProvider";
import { AxiosProvider } from "./contexts/AxiosProvider";
import {
  MaterialDesignContent,
  SnackbarProvider,
  closeSnackbar,
} from "notistack";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

function App() {
  return (
    <div>
      {/* Provide Axios instance to the entire app */}
      <AxiosProvider>
        {/* Provide authentication context to the entire app */}
        <AuthProvider>
          {/* Provide workflow context to the entire app */}
          <WorkflowProvider>
            {/* SnackbarProvider to handle notifications */}
            <SnackbarProvider
              maxSnack={3} // Maximum number of snackbars displayed at once
              Components={{
                success: MaterialDesignContent,
                error: MaterialDesignContent,
                warning: MaterialDesignContent,
              }}
              iconVariant={{
                error: (
                  <ErrorOutlineIcon sx={{ marginRight: 1, marginLeft: 0 }} />
                ),
              }}
              action={(snackbarId) => (
                // Action button to close the snackbar
                <IconButton
                  size="small"
                  aria-label="close"
                  color="inherit"
                  onClick={() => closeSnackbar(snackbarId)}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              )}
            >
              {/* Render the application routes */}
              <Routes />
            </SnackbarProvider>
          </WorkflowProvider>
        </AuthProvider>
      </AxiosProvider>
    </div>
  );
}

export default App;
